import Icon from '../components/Icon.vue'

Icon.register({"cloud":{"width":1920,"height":1792,"paths":[{"d":"M1920 1152q0 159-112.5 271.5t-271.5 112.5h-1088q-185 0-316.5-131.5t-131.5-316.5q0-132 71-241.5t187-163.5q-2-28-2-43 0-212 150-362t362-150q158 0 286.5 88t187.5 230q70-62 166-62 106 0 181 75t75 181q0 75-41 138 129 30 213 134.5t84 239.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud.js
// module id = HOA6
// module chunks = 1